<script>
  import { runMenuItem } from './menu-command-router.js';

  let { items, activeItemIndex, activeApp, onclose } = $props();
</script>

<div class="menu-popover" role="menu" tabindex="-1" onmouseleave={onclose}>
  {#each items as item, i (i)}
    {#if item.separator}
      <div class="menu-separator"></div>
    {:else}
      <button
        class="menu-item"
        class:disabled={item.disabled || item.heading}
        class:active={activeItemIndex === i}
        onclick={() => {
          runMenuItem(item, activeApp);
          onclose?.();
        }}
      >
        <span>{item.label}</span>
        {#if item.shortcut}<kbd>{item.shortcut}</kbd>{/if}
      </button>
    {/if}
  {/each}
</div>

<style>
  .menu-popover {
    position: absolute;
    top: 24px;
    left: 0;
    z-index: 10010;
    width: max-content;
    min-width: 188px;
    max-width: 320px;
    padding: 4px 0;
    color: #e0e0e0;
    background:
      repeating-linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.025) 0 1px,
        rgba(0, 0, 0, 0.035) 1px 2px
      ),
      rgba(40, 43, 43, 0.98);
    border: 1px solid rgba(0, 0, 0, 0.8);
    border-radius: 0 0 4px 4px;
    box-shadow:
      0 14px 34px rgba(0, 0, 0, 0.6),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
  }
  .menu-item {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 16px;
    align-items: center;
    width: 100%;
    min-height: 22px;
    padding: 0 18px 0 20px;
    color: #e0e0e0;
    font: 13px var(--font);
    text-align: left;
    background: transparent;
    border: 0;
    cursor: default;
  }
  .menu-item:hover:not(.disabled),
  .menu-item.active:not(.disabled) {
    color: #fff;
    background: linear-gradient(to bottom, var(--graphite-select-top), var(--graphite-select-bot));
    box-shadow:
      inset 0 1px rgba(255, 255, 255, 0.18),
      inset 0 -1px rgba(0, 0, 0, 0.28);
  }
  .menu-item span {
    white-space: nowrap;
  }
  .menu-item.disabled {
    color: #666;
  }
  .menu-item kbd {
    font: 12px var(--font);
    color: inherit;
  }
  .menu-separator {
    height: 1px;
    margin: 3px 1px;
    background: #111;
    border-bottom: 1px solid #444;
  }
</style>
